
import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isShareMenuOpen, setIsShareMenuOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  const shareUrl = window.location.href;
  const shareTitle = 'Desumanização Noticiada - A Versão Oficial da Violência';
  const shareText = 'Confira esta investigação sobre a cobertura jornalística de operações policiais no Brasil';

  const handleShare = (platform: 'copy' | 'whatsapp' | 'twitter' | 'facebook' | 'linkedin') => {
    let url = '';
    
    switch (platform) {
      case 'copy':
        navigator.clipboard.writeText(shareUrl);
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
        break;
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(shareText + '\n\n' + shareUrl)}`;
        window.open(url, '_blank');
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
        window.open(url, '_blank', 'width=600,height=600');
        break;
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        window.open(url, '_blank', 'width=600,height=600');
        break;
      case 'linkedin':
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        window.open(url, '_blank', 'width=600,height=600');
        break;
    }
    
    if (platform !== 'copy') {
      setIsShareMenuOpen(false);
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0" style={{ marginLeft: '0.8cm' }}>
            <h1 className="text-xl font-semibold text-gray-900 font-serif">
              Desumanização Noticiada
            </h1>
          </div>

          {/* Desktop Navigation - Centralizado */}
          <nav className="hidden md:flex space-x-8 absolute left-1/2 transform -translate-x-1/2">
            <a href="#reportagem" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Reportagem
            </a>
            <a href="#dados" className="text-gray-700 hover:text-gray-900 font-medium transition-colors">
              Dados
            </a>
          </nav>

          {/* CTA Button with Share Menu */}
          <div className="hidden md:block relative">
            <Button 
              variant="primary" 
              size="sm"
              onClick={() => setIsShareMenuOpen(!isShareMenuOpen)}
            >
              Compartilhar
              <i className="ri-arrow-down-s-line ml-1"></i>
            </Button>
            
            {isShareMenuOpen && (
              <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                <button
                  onClick={() => handleShare('copy')}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer transition-colors"
                >
                  <i className={`${copySuccess ? 'ri-check-line text-green-600' : 'ri-link'} mr-3 text-lg`}></i>
                  {copySuccess ? 'Link copiado!' : 'Copiar link'}
                </button>
                <div className="border-t border-gray-200 my-2"></div>
                <button
                  onClick={() => handleShare('whatsapp')}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer transition-colors"
                >
                  <i className="ri-whatsapp-line mr-3 text-lg"></i>
                  WhatsApp
                </button>
                <button
                  onClick={() => handleShare('twitter')}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer transition-colors"
                >
                  <i className="ri-twitter-x-line mr-3 text-lg"></i>
                  Twitter
                </button>
                <button
                  onClick={() => handleShare('facebook')}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer transition-colors"
                >
                  <i className="ri-facebook-box-line mr-3 text-lg"></i>
                  Facebook
                </button>
                <button
                  onClick={() => handleShare('linkedin')}
                  className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 flex items-center cursor-pointer transition-colors"
                >
                  <i className="ri-linkedin-box-line mr-3 text-lg"></i>
                  LinkedIn
                </button>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg">
            <nav className="px-4 py-4 space-y-3">
              <a 
                href="#reportagem" 
                className="block text-gray-700 hover:text-gray-900 font-medium transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Reportagem
              </a>
              <a 
                href="#dados" 
                className="block text-gray-700 hover:text-gray-900 font-medium transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Dados
              </a>
              <div className="pt-2 border-t border-gray-200">
                <button
                  onClick={() => handleShare('copy')}
                  className="w-full text-left text-gray-700 hover:text-gray-900 font-medium transition-colors py-2 flex items-center cursor-pointer"
                >
                  <i className={`${copySuccess ? 'ri-check-line text-green-600' : 'ri-link'} mr-2`}></i>
                  {copySuccess ? 'Link copiado!' : 'Copiar link'}
                </button>
                <button
                  onClick={() => handleShare('whatsapp')}
                  className="w-full text-left text-gray-700 hover:text-gray-900 font-medium transition-colors py-2 flex items-center cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  WhatsApp
                </button>
                <button
                  onClick={() => handleShare('twitter')}
                  className="w-full text-left text-gray-700 hover:text-gray-900 font-medium transition-colors py-2 flex items-center cursor-pointer"
                >
                  <i className="ri-twitter-x-line mr-2"></i>
                  Twitter
                </button>
                <button
                  onClick={() => handleShare('facebook')}
                  className="w-full text-left text-gray-700 hover:text-gray-900 font-medium transition-colors py-2 flex items-center cursor-pointer"
                >
                  <i className="ri-facebook-box-line mr-2"></i>
                  Facebook
                </button>
                <button
                  onClick={() => handleShare('linkedin')}
                  className="w-full text-left text-gray-700 hover:text-gray-900 font-medium transition-colors py-2 flex items-center cursor-pointer"
                >
                  <i className="ri-linkedin-box-line mr-2"></i>
                  LinkedIn
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
